import React from "react";
import { getPartnerGuid } from "../lib/access.es6";
import { PARTNERS_GUID_ENUM } from "./PartnersEnum";

// Phase E — configurable renderers (safe: only used as default branch fallbacks)
import CustomerStatusConfigurable from "../containers/CustomerStatusConfigurable/index";
import ClaimInitiationConfigurable from "../containers/ClaimInitiationConfigurable/index";
import IppLauncher from "../containers/IppLauncher/index";

import { default as ClaimsDashboardDefault } from "../containers/ClaimsDashboard/index.es6";
import { default as ClaimsDashboardKTDA } from "../partner-apps/ktda/ClaimDashboard";
import { default as ClaimsDashboardAccessBank } from "../partner-apps/AccessBank/ClaimDashboard";
import { default as ClaimDashboardBboxx } from "../partner-apps/BboxxKenya/ClaimDashboard";
import { default as ClaimDashboardNGSGroup } from "../partner-apps/NgsUganda/ClaimDashboard/Components/DeathClaims/index";
import { default as ClaimDashboardHe } from "../partner-apps/HealthEntrepreneurs/ClaimDashboard/index";
import { default as ClaimDashboardMzanu } from "../partner-apps/Mzanu/ClaimDashboard/index";


import { default as CustomerStatusKTDA } from "../containers/PolicyV2CustomerStatus/CustomerStatusv2";
import { default as CustomerStatusDefault } from "../containers/CustomerScreen/index.es6";

import { default as CustomerStatusAccessBank } from "../partner-apps/AccessBank/CustomerStatus/index";
import { default as BboxxKenyaCustomerStatus } from "../partner-apps/BboxxKenya/CustomerStatus/index";
import { default as CustomerStatusNGS } from "../partner-apps/NgsUganda/CustomerStatus/index";
import { default as CustomerStatusRealPeople } from "../partner-apps/RealPeople/CustomerStatus/index";
import { default as CustomerStatusIncMotor } from "../partner-apps/InclMotor/CustomerStatus/index";
import { default as CustomerStatusMalipoWws } from "../partner-apps/MalipoWws/CustomerStatus/index";
import { default as CustomerStatusOldMutualUganda } from "../partner-apps/OldMutualUganda-Postbank/CustomerStatus/index";

import { default as PolicyAdminAccessBank } from "../partner-apps/AccessBank/PolicyAdmin/index";
import { default as PolicyAmendmentAccessBank } from "../partner-apps/AccessBank/PolicyAmend/index";
import { default as PolicyAmendmentOldMutualUganda } from "../partner-apps/OldMutualUganda-Postbank/PolicyAmend/index";
import { default as PolicyAmendmentSamba } from "../partner-apps/Samba/PolicyAmend/index";
import { default as PolicyAmendmentOldMutualKenya } from "../partner-apps/OldMutualKenya/PolicyAmend/index";
import { default as PolicyAdminIncMotor } from "../partner-apps/InclMotor/PolicyAdmin/index";
import { default as PolicyHolderOldmutualUgandaPostbank } from "../partner-apps/OldMutualUganda-Postbank/PolicyAdmin/index";
import { default as PolicyHolderOldMutualUgandaRotary } from "../partner-apps/OldMutualUganda-Rotary/PolicyAdmin/index";
import { default as PolicyHolderOldMutualUgandaNamirembe } from "../partner-apps/OldMutualUganda-Namirembe/PolicyAdmin/index";
import { default as PolicyHolderCentenaryBank } from "../partner-apps/OldMutualUganda-Centenary/PolicyAdmin/index";
import { default as PolicyHolderDFCU } from "../partner-apps/OldMutualUganda-DFCU/PolicyAdmin/index";
import { default as PolicyAdminHealthEnterpreneuers } from "../partner-apps/HealthEntrepreneurs/PolicyAdmin/index";

import { default as BulkPolicyOnboardingKTDA } from "../partner-apps/ktda/BulkPolicyOnboarding/index";
import { default as FailedEnteriesKTDA } from "../partner-apps/ktda/FailedEnteries/index";

import { default as BulkPaymentsKTDA } from "../partner-apps/ktda/BulkPayments/index";
import { default as FailedPaymentsEnteriesKTDA } from "../partner-apps/ktda/FailedPaymentsEnteries/index";

import { default as PoliciesDashboardAccessBank } from "../partner-apps/AccessBank/PoliciesDashboard/index.js";
import { default as RecentPoliciesShared } from "../containers/RecentPolicies/index";
import { default as OmmAmlDesk } from "../partner-apps/OldMutualMalawi/PoliciesDashboard/AmlDesk/index";
import { default as EmplifePlusPoliciesDashboard } from "../containers/PoliciesOverview/index.es6";
import { default as OmmPolicyProcessing } from "../partner-apps/OldMutualMalawi/PoliciesProcessing/index";
import { default as OmmNewBusiness } from "../partner-apps/OldMutualMalawi/PoliciesDashboard/NewBusiness/index";

import PageNotFound from "../containers/PageNotFound/index.es6";
import Policyv2 from "../containers/Policyv2";

import { default as ClaimsProcessingKTDA } from "../partner-apps/ktda/ClaimsProcessing/index";
import { default as ClaimsProcessingAccessBank } from "../partner-apps/AccessBank/ClaimsProcessing/index";
import { default as ClaimsProcessingBboxx } from "../partner-apps/BboxxKenya/ClaimsProcessing/index";
import { default as ClaimProcessingNGSGroup } from "../partner-apps/NgsUganda/ClaimsProcessing/index";
import { default as ClaimProcessingRealPeople } from "../partner-apps/RealPeople/ClaimsProcessing/index";
import { default as ClaimProcessingEunifin } from "../partner-apps/EunifinGhana/ClaimsProcessing/index";
import { default as ClaimProcessingHe } from "../partner-apps/HealthEntrepreneurs/ClaimsProcessing/index";
import { default as ClaimProcessingCoverLink } from "../partner-apps/CoverLink/ClaimProcessing/index";
import { default as ClaimProcessingMzanu } from "../partner-apps/Mzanu/ClaimsProcessing/index";
import { default as ClaimProcessingOldMutualMalawi } from "../partner-apps/OldMutualMalawi/ClaimsProcessing/index";

import { default as ClaimInitiationKTDA } from "../partner-apps/ktda/ClaimInitiation/index";
import { default as ClaimInitiationAccessBank } from "../partner-apps/AccessBank/ClaimInitiation/index";
import { default as ClaimInitiationBboxx } from "../partner-apps/BboxxKenya/ClaimInitiation/index";
import { default as ClaimInitiationRealPeople } from "../partner-apps/RealPeople/ClaimInitiation/index";
import { default as ClaimInitiationEunifin } from "../partner-apps/EunifinGhana/ClaimInitiation/index";
import { default as ClaimInitiationHe } from "../partner-apps/HealthEntrepreneurs/ClaimInitiation/index";
import { default as ClaimInitiationMzanu } from "../partner-apps/Mzanu/ClaimInitiation/index";
import { default as ClaimInitiationOldMutualMalawi } from "../partner-apps/OldMutualMalawi/ClaimInitiation/index";
import { default as ClaimInitiationCoverLink } from "../partner-apps/CoverLink/ClaimInitiation/index";

import { default as KTDAHomePage } from "../partner-apps/ktda/HomePageCta/index";
import { default as AccessBankHomePage } from "../partner-apps/AccessBank/HomePageCta/index";
import { default as BboxxHomePage } from "../partner-apps/BboxxKenya/HomePageCta/index";
import SimpleHomePage from "../containers/CustomerScreen/components/HomePageCta/index";
import { default as NGSHomepage } from "../partner-apps/NgsUganda/HomePageCta/index";
import { default as RealPeopleHomepage } from "../partner-apps/RealPeople/HomePageCta/index";
import { default as InclMotorHomepage } from "../partner-apps/InclMotor/HomePageCta/index";
import { default as MalipoWWSHomepage } from "../partner-apps/MalipoWws/HomePageCta/index";

import { default as CoverLinkHomePage } from "../partner-apps/CoverLink/HomePageCta/index";
import { default as MzanuHomepage } from '../partner-apps/Mzanu/HomePageCta/index';
import { default as HealthEntrepreneursHomePage } from '../partner-apps/HealthEntrepreneurs/HomePageCta/index';

import { default as AccessBankPolicyProcessing } from "../partner-apps/AccessBank/PoliciesProcessing/index";
import { default as BboxxPolicyProcessing } from "../partner-apps/BboxxKenya/PoliciesProcessing/index";
import { default as NGSGroupPolicyProcessing } from "../partner-apps/NgsUganda/PoliciesProcessing/index";
import { default as RealPeoplePolicyProcessing } from "../partner-apps/RealPeople/PoliciesProcessing/index";
import { default as InclMotorPolicyProcessing } from "../partner-apps/InclMotor/PoliciesProcessing/index";
import { default as MalipoWwsPolicyProcessing } from "../partner-apps/MalipoWws/PoliciesProcessing/index";
import { default as CoverLinkPoliciesProcessing } from "../partner-apps/CoverLink/PoliciesProcessing/index";

import KnowledgeBaseShared from "../components/KnowledgeBase/index";
import ViewGuideShared from "../components/KnowledgeBase/components/ViewGuide";

import { default as ElasticSearch } from "../containers/ElasticSearch/index";

import { default as RealPeopleDeathClaims } from "../partner-apps/RealPeople/ClaimDashboard/Components/DeathClaims/index";
import { default as RealPeopleDisabilityClaims } from "../partner-apps/RealPeople/ClaimDashboard/Components/DisabilityClaims/index";
import { default as RealPeopleHospitalClaims } from "../partner-apps/RealPeople/ClaimDashboard/Components/HospitalClaims/index";
import { default as RealPeopleLastExpenseClaims } from "../partner-apps/RealPeople/ClaimDashboard/Components/LastExpenseClaims/index";
import { default as RealPeoplePropertyClaims } from "../partner-apps/RealPeople/ClaimDashboard/Components/PropertyClaims/index";
import { default as HospitalClaimDashboardKtda } from "../partner-apps/ktda/ClaimDashboard/Components/HospitalClaims/index";
import { default as DeathClaimsDashboardKtda } from "../partner-apps/ktda/ClaimDashboard/Components/DeathClaims/index";
import { default as DeathClaimsDashboardAccessbank } from "../partner-apps/AccessBank/ClaimDashboard/index";
import { default as ReimbursementClaimsDashboardKtda } from "../partner-apps/ktda/ClaimDashboard/Components/ ReimbursementClaims/index";
import { default as BboxxHospitalClaimsDashboard } from "../partner-apps/BboxxKenya/ClaimDashboard/Components/BboxxHospitalClaims/index";
import { default as BboxxDeathClaimsDashbaord } from "../partner-apps/BboxxKenya/ClaimDashboard/Components/BboxxDeathClaims/index";
import { default as BboxxDeviceDamageClaimsDashboard } from "../partner-apps/BboxxKenya/ClaimDashboard/Components/BboxxDeviceDamageClaims/index";
import { default as BboxxDisabilityClaimsDashboard } from "../partner-apps/BboxxKenya/ClaimDashboard/Components/BboxxDisabilityClaims/index";
import { default as BboxxDeviceTheftClaimsDashboard } from "../partner-apps/BboxxKenya/ClaimDashboard/Components/BboxxDeviceTheftClaims/index";
import { default as HeHospitalClaimsDashboard } from "../partner-apps/HealthEntrepreneurs/ClaimDashboard/Components/HospitalClaims/index";
import { default as HeLastExpenseDasboared } from "../partner-apps/HealthEntrepreneurs/ClaimDashboard/Components/DeathClaims/index";
import { default as HeCancerCareClaims } from "../partner-apps/HealthEntrepreneurs/ClaimDashboard/Components/CancerClaims/index";

import { default as EunifinCriticalIllnessClaims } from "../partner-apps/EunifinGhana/ClaimDashboard/Components/CriticalIllnessClaims/index";
import ClaimsProcessingRefactored from "../containers/ClaimsProcessingRefactored";

import { default as MzanuHospiCashIllnessBenefit } from "../partner-apps/Mzanu/ClaimDashboard/Components/HospitalClaims/index";
import { default as MzanuHospitalCashAccidentBenefit } from "../partner-apps/Mzanu/ClaimDashboard/Components/HospitalCashAccidentClaims/index";

import { default as MzanuFuneralClaims } from "../partner-apps/Mzanu/ClaimDashboard/Components/FuneralClaims/index";
import { default as OmmFuneralClaims } from "../partner-apps/OldMutualMalawi/ClaimDashboard/Components/FuneralClaims/index";
import { default as OmmHospitalClaims } from "../partner-apps/OldMutualMalawi/ClaimDashboard/Components/HospitalClaims/index";


import { default as CoverLinkMedicalCashClaims } from "../partner-apps/CoverLink/ClaimDashboard/Components/MedicalCashClaims/index";

import { default as CoverLinkLegalClaims } from "../partner-apps/CoverLink/ClaimDashboard/Components/LegalClaims/index";
import { default as GeneratePolicyCoverLink } from "../partner-apps/CoverLink/PolicyAdmin/index";
import { default as GeneratePolicyMzanu } from "../partner-apps/Mzanu/PolicyAdmin/index";
import { default as GeneratePolicyOldMutualKenya } from "../partner-apps/OldMutualKenya/PolicyAdmin/index";
import { default as GeneratePolicyOldMutualMalawi } from "../partner-apps/OldMutualMalawi/PolicyAdmin/index";

const partnerGuid = getPartnerGuid();

export const HomePage = (props) => {
  switch (partnerGuid) {

    case PARTNERS_GUID_ENUM.KTDA:
      return <KTDAHomePage {...props} />;
    case PARTNERS_GUID_ENUM.ASPIN_PLUS:
    case PARTNERS_GUID_ENUM.ACCESS_BANK:
    case PARTNERS_GUID_ENUM.INSOLCOMPLEX:
      return <AccessBankHomePage {...props} />;
    case PARTNERS_GUID_ENUM.BBOX_KENYA:
    case PARTNERS_GUID_ENUM.BBOX_RWANDA:
      return <BboxxHomePage {...props} />;
    case PARTNERS_GUID_ENUM.NGS_UGANDA:
      return <NGSHomepage {...props} />;
    case PARTNERS_GUID_ENUM.REAL_PEOPLE:
    case PARTNERS_GUID_ENUM.SHIPRAZOR_SOUTH_AFRICA:
    case PARTNERS_GUID_ENUM.SHIPRAZOR_KENYA:
    case PARTNERS_GUID_ENUM.EUNIFIN_GHANA:
    case PARTNERS_GUID_ENUM.EUNIFIN_SENEGAL:
    case PARTNERS_GUID_ENUM.SENTI:
      return <RealPeopleHomepage {...props} />;
    case PARTNERS_GUID_ENUM.INCL_MOTOR:
      return <InclMotorHomepage {...props} />;

    case PARTNERS_GUID_ENUM.MALIPOWWS:
      return <MalipoWWSHomepage {...props} />;

    case PARTNERS_GUID_ENUM.HEALTH_ENTREPRENEURS:
      return <HealthEntrepreneursHomePage {...props} />;

    case PARTNERS_GUID_ENUM.OLDMUTUAL_UGANDA_POSTBANK:
    case PARTNERS_GUID_ENUM.OLDMUTUAL_UGANDA_ROTARY:
    case PARTNERS_GUID_ENUM.OLDMUTUAL_UGANDA_FLP:
    case PARTNERS_GUID_ENUM.OLDMUTUAL_CENTENARY_BANK:
    case PARTNERS_GUID_ENUM.OLDMUTUAL_DFCU_UG:
    case PARTNERS_GUID_ENUM.OLDMUTUAL_UGANDA_NAMIREMBE:
    case PARTNERS_GUID_ENUM.COVER_LINK:
    case PARTNERS_GUID_ENUM.OLDMUTUAL_UGANDA_LIONSCLUB:
      return <CoverLinkHomePage {...props} />;

    case PARTNERS_GUID_ENUM.MZANU:
    case PARTNERS_GUID_ENUM.OLDMUTUAL_KENYA:
    case PARTNERS_GUID_ENUM.OLDMUTUAL_MALAWI:
    case PARTNERS_GUID_ENUM.SAMBA:
    case PARTNERS_GUID_ENUM.marketplace_a: 
    case PARTNERS_GUID_ENUM.marketplace_b: 
    case PARTNERS_GUID_ENUM.marketplace_c: 
      return <MzanuHomepage {...props} />;



    default:
      return <SimpleHomePage {...props} />;
  }
};

export const SimpleClaimProcessing = (props) => {
  return <ClaimsProcessingRefactored {...props} />;
};

export const CustomerStatusX = (props) => {
  switch (partnerGuid) {
    case PARTNERS_GUID_ENUM.KTDA:
      return <CustomerStatusKTDA {...props} />;

    case PARTNERS_GUID_ENUM.ACCESS_BANK:
    case PARTNERS_GUID_ENUM.INSOLCOMPLEX:
    case PARTNERS_GUID_ENUM.ASPIN_PLUS:
      return <CustomerStatusAccessBank {...props} />;

    case PARTNERS_GUID_ENUM.BBOX_KENYA:
    case PARTNERS_GUID_ENUM.BBOX_RWANDA:
      return <BboxxKenyaCustomerStatus {...props} />;

    // case PARTNERS_GUID_ENUM.ORANGE:
    //   const FLAG_NAME = "Orange Customer Status";

    //   const component = isFeatureFlagEnabled(FLAG_NAME) ? (
    //     <CustomerStatusOrange {...props} />
    //   ) : (
    //     <CustomerStatusDefault {...props} />
    //   );
    //   return component;

    case PARTNERS_GUID_ENUM.NGS_UGANDA:
      return <CustomerStatusNGS {...props} />;

    case PARTNERS_GUID_ENUM.REAL_PEOPLE:
    case PARTNERS_GUID_ENUM.SHIPRAZOR_SOUTH_AFRICA:
    case PARTNERS_GUID_ENUM.SHIPRAZOR_KENYA:
    case PARTNERS_GUID_ENUM.EUNIFIN_GHANA:
    case PARTNERS_GUID_ENUM.EUNIFIN_SENEGAL:
    case PARTNERS_GUID_ENUM.SENTI:
      return <CustomerStatusRealPeople {...props} />;

    case PARTNERS_GUID_ENUM.MMI_GHANA:
      return <CustomerStatusRealPeople {...props} />;

    case PARTNERS_GUID_ENUM.INCL_MOTOR:
      return <CustomerStatusIncMotor {...props} />;

    case PARTNERS_GUID_ENUM.MALIPOWWS:
    case PARTNERS_GUID_ENUM.HEALTH_ENTREPRENEURS:
    case PARTNERS_GUID_ENUM.OLDMUTUAL_UGANDA_FLP:
      return <CustomerStatusMalipoWws {...props} />;

    case PARTNERS_GUID_ENUM.OLDMUTUAL_UGANDA_POSTBANK:
    case PARTNERS_GUID_ENUM.OLDMUTUAL_UGANDA_ROTARY:
    case PARTNERS_GUID_ENUM.OLDMUTUAL_UGANDA_NAMIREMBE:
    case PARTNERS_GUID_ENUM.OLDMUTUAL_CENTENARY_BANK:
    case PARTNERS_GUID_ENUM.OLDMUTUAL_DFCU_UG:
    case PARTNERS_GUID_ENUM.COVER_LINK:
    case PARTNERS_GUID_ENUM.MZANU:
    case PARTNERS_GUID_ENUM.OLDMUTUAL_KENYA:
    case PARTNERS_GUID_ENUM.OLDMUTUAL_UGANDA_LIONSCLUB:
    case PARTNERS_GUID_ENUM.OLDMUTUAL_MALAWI:
    case PARTNERS_GUID_ENUM.SAMBA:
    case PARTNERS_GUID_ENUM.marketplace_a: 
    case PARTNERS_GUID_ENUM.marketplace_b: 
    case PARTNERS_GUID_ENUM.marketplace_c: 
      return <CustomerStatusOldMutualUganda {...props} />;

    default:
      // Phase E: use config-driven renderer for new/unconfigured partners.
      // Falls back to CustomerStatusDefault internally if no org config found.
      return (
        <CustomerStatusConfigurable
          fallback={<CustomerStatusDefault {...props} />}
          {...props}
        />
      );
  }
};

export const GeneratePolicy = (props) => {
  switch (partnerGuid) {
    case PARTNERS_GUID_ENUM.COVER_LINK:
      return <GeneratePolicyCoverLink {...props} />;

    case PARTNERS_GUID_ENUM.OLDMUTUAL_UGANDA_POSTBANK:
    case PARTNERS_GUID_ENUM.OLDMUTUAL_UGANDA_FLP:
      case PARTNERS_GUID_ENUM.OLDMUTUAL_UGANDA_LIONSCLUB:
      return <PolicyHolderOldmutualUgandaPostbank {...props} />;

    case PARTNERS_GUID_ENUM.OLDMUTUAL_UGANDA_ROTARY:
      return <PolicyHolderOldMutualUgandaRotary {...props} />

    case PARTNERS_GUID_ENUM.OLDMUTUAL_UGANDA_NAMIREMBE:
      return <PolicyHolderOldMutualUgandaNamirembe {...props} />
    case PARTNERS_GUID_ENUM.OLDMUTUAL_CENTENARY_BANK:
      return <PolicyHolderCentenaryBank {...props} />

    case PARTNERS_GUID_ENUM.OLDMUTUAL_DFCU_UG:
      return <PolicyHolderDFCU {...props} />

    case PARTNERS_GUID_ENUM.MZANU:
      return <GeneratePolicyMzanu {...props} />;

    case PARTNERS_GUID_ENUM.OLDMUTUAL_KENYA:
    case PARTNERS_GUID_ENUM.marketplace_a: 
    case PARTNERS_GUID_ENUM.marketplace_b: 
    case PARTNERS_GUID_ENUM.marketplace_c: 
      return <GeneratePolicyOldMutualKenya {...props} />;
    
    case PARTNERS_GUID_ENUM.OLDMUTUAL_MALAWI:
      return <GeneratePolicyOldMutualMalawi {...props} />;

    default:
      return <CustomerStatusDefault {...props} />;
  }
};

export const PolicyAdmin = (props) => {
  switch (partnerGuid) {
    case PARTNERS_GUID_ENUM.ACCESS_BANK:
    case PARTNERS_GUID_ENUM.ASPIN_PLUS:
    case PARTNERS_GUID_ENUM.BBOX_KENYA:
    case PARTNERS_GUID_ENUM.BBOX_RWANDA:
    case PARTNERS_GUID_ENUM.INSOLCOMPLEX:
      return <PolicyAdminAccessBank {...props} />;
    case PARTNERS_GUID_ENUM.KTDA:
      return <Policyv2 />;

    case PARTNERS_GUID_ENUM.INCL_MOTOR:
      return <PolicyAdminIncMotor {...props} />;

    case PARTNERS_GUID_ENUM.OLDMUTUAL_UGANDA_POSTBANK:
    case PARTNERS_GUID_ENUM.OLDMUTUAL_UGANDA_ROTARY:
    case PARTNERS_GUID_ENUM.OLDMUTUAL_UGANDA_NAMIREMBE:
    case PARTNERS_GUID_ENUM.OLDMUTUAL_UGANDA_FLP:
    case PARTNERS_GUID_ENUM.OLDMUTUAL_CENTENARY_BANK:
    case PARTNERS_GUID_ENUM.OLDMUTUAL_DFCU_UG:
    case PARTNERS_GUID_ENUM.OLDMUTUAL_UGANDA_LIONSCLUB:
    case PARTNERS_GUID_ENUM.marketplace_a: 
    case PARTNERS_GUID_ENUM.marketplace_b: 
    case PARTNERS_GUID_ENUM.marketplace_c: 
      return <PolicyHolderOldmutualUgandaPostbank {...props} />;

    case PARTNERS_GUID_ENUM.HEALTH_ENTREPRENEURS:
      return <PolicyAdminHealthEnterpreneuers {...props} />;

    default:
      return <CustomerStatusDefault {...props} />;
  }
};

export const PolicyAmendment = (props) => {
  switch (partnerGuid) {
    case PARTNERS_GUID_ENUM.ACCESS_BANK:
      return <PolicyAmendmentAccessBank {...props} />;
    case PARTNERS_GUID_ENUM.OLDMUTUAL_MALAWI:
      return <GeneratePolicyOldMutualMalawi {...props} />;
    case PARTNERS_GUID_ENUM.OLDMUTUAL_UGANDA_POSTBANK:
    case PARTNERS_GUID_ENUM.OLDMUTUAL_UGANDA_LIONSCLUB:
    case PARTNERS_GUID_ENUM.OLDMUTUAL_UGANDA_ROTARY:
    case PARTNERS_GUID_ENUM.OLDMUTUAL_UGANDA_NAMIREMBE:
    case PARTNERS_GUID_ENUM.OLDMUTUAL_CENTENARY_BANK:
    case PARTNERS_GUID_ENUM.OLDMUTUAL_DFCU_UG:
    case PARTNERS_GUID_ENUM.marketplace_a: 
    case PARTNERS_GUID_ENUM.marketplace_b: 
    case PARTNERS_GUID_ENUM.marketplace_c: 
      return <PolicyAmendmentOldMutualUganda {...props} />;

    case PARTNERS_GUID_ENUM.SAMBA:
      return <PolicyAmendmentSamba {...props} />;

    case PARTNERS_GUID_ENUM.OLDMUTUAL_KENYA:
      return <PolicyAmendmentOldMutualKenya {...props} />;

    default:
      return <PageNotFound />;
  }
};

export const PolicyProcessing = (props) => {
  switch (partnerGuid) {
    case PARTNERS_GUID_ENUM.ACCESS_BANK:
    case PARTNERS_GUID_ENUM.ASPIN_PLUS:
    case PARTNERS_GUID_ENUM.INSOLCOMPLEX:
    case PARTNERS_GUID_ENUM.OLDMUTUAL_UGANDA_POSTBANK:
    case PARTNERS_GUID_ENUM.OLDMUTUAL_UGANDA_ROTARY:
    case PARTNERS_GUID_ENUM.OLDMUTUAL_UGANDA_NAMIREMBE:
    case PARTNERS_GUID_ENUM.OLDMUTUAL_UGANDA_FLP:
    case PARTNERS_GUID_ENUM.OLDMUTUAL_CENTENARY_BANK:
    case PARTNERS_GUID_ENUM.OLDMUTUAL_DFCU_UG:
    case PARTNERS_GUID_ENUM.MZANU:
    case PARTNERS_GUID_ENUM.OLDMUTUAL_KENYA:
    case PARTNERS_GUID_ENUM.OLDMUTUAL_UGANDA_LIONSCLUB:
    case PARTNERS_GUID_ENUM.SAMBA:
    case PARTNERS_GUID_ENUM.marketplace_a: 
    case PARTNERS_GUID_ENUM.marketplace_b: 
    case PARTNERS_GUID_ENUM.marketplace_c: 
      return <AccessBankPolicyProcessing {...props} />;

    case PARTNERS_GUID_ENUM.COVER_LINK:
      return <CoverLinkPoliciesProcessing {...props} />;

    case PARTNERS_GUID_ENUM.OLDMUTUAL_MALAWI:
      return <OmmPolicyProcessing {...props} />;
    case PARTNERS_GUID_ENUM.BBOX_KENYA:
    case PARTNERS_GUID_ENUM.BBOX_RWANDA:
      return <BboxxPolicyProcessing {...props} />;

    case PARTNERS_GUID_ENUM.NGS_UGANDA:
    case PARTNERS_GUID_ENUM.SHIPRAZOR_SOUTH_AFRICA:
    case PARTNERS_GUID_ENUM.SHIPRAZOR_KENYA:
      return <NGSGroupPolicyProcessing {...props} />;

    case PARTNERS_GUID_ENUM.REAL_PEOPLE:
    case PARTNERS_GUID_ENUM.EUNIFIN_GHANA:
    case PARTNERS_GUID_ENUM.EUNIFIN_SENEGAL:
    case PARTNERS_GUID_ENUM.SENTI:
    case PARTNERS_GUID_ENUM.MMI_GHANA:
      return <RealPeoplePolicyProcessing {...props} />;

    case PARTNERS_GUID_ENUM.KTDA:
      return <Policyv2 />;

    case PARTNERS_GUID_ENUM.INCL_MOTOR:
      return <InclMotorPolicyProcessing {...props} />;

    case PARTNERS_GUID_ENUM.MALIPOWWS:
    case PARTNERS_GUID_ENUM.HEALTH_ENTREPRENEURS:
      return <MalipoWwsPolicyProcessing {...props} />;

    default:
      return <CustomerStatusDefault {...props} />;
  }
};

export const ClaimsDashboard = (props) => {
  switch (partnerGuid) {
    case PARTNERS_GUID_ENUM.KTDA:
      return <ClaimsDashboardKTDA />;
    case PARTNERS_GUID_ENUM.ACCESS_BANK:
    case PARTNERS_GUID_ENUM.ASPIN_PLUS:
    case PARTNERS_GUID_ENUM.INSOLCOMPLEX:
    case PARTNERS_GUID_ENUM.OLDMUTUAL_UGANDA_FLP:
    case PARTNERS_GUID_ENUM.OLDMUTUAL_UGANDA_ROTARY:
    case PARTNERS_GUID_ENUM.OLDMUTUAL_UGANDA_NAMIREMBE:
    case PARTNERS_GUID_ENUM.OLDMUTUAL_UGANDA_POSTBANK:
    case PARTNERS_GUID_ENUM.OLDMUTUAL_CENTENARY_BANK:
    case PARTNERS_GUID_ENUM.OLDMUTUAL_DFCU_UG:
    case PARTNERS_GUID_ENUM.OLDMUTUAL_UGANDA_LIONSCLUB:
    case PARTNERS_GUID_ENUM.SAMBA:
    // Emple's claims live in the complex claims service, same screen as the other complex partners.
    case PARTNERS_GUID_ENUM.MMI_GHANA:
     case PARTNERS_GUID_ENUM.marketplace_a: 
    case PARTNERS_GUID_ENUM.marketplace_b: 
    case PARTNERS_GUID_ENUM.marketplace_c: 
      return <ClaimsDashboardAccessBank />;
    case PARTNERS_GUID_ENUM.BBOX_KENYA:
    case PARTNERS_GUID_ENUM.BBOX_RWANDA:
      return <ClaimDashboardBboxx />;

    case PARTNERS_GUID_ENUM.NGS_UGANDA:
    case PARTNERS_GUID_ENUM.SHIPRAZOR_SOUTH_AFRICA:
    case PARTNERS_GUID_ENUM.SHIPRAZOR_KENYA:
      return <ClaimDashboardNGSGroup {...props} />;

    case PARTNERS_GUID_ENUM.HEALTH_ENTREPRENEURS:
      return <ClaimDashboardHe {...props} />;

    case PARTNERS_GUID_ENUM.MZANU:
      return <ClaimDashboardMzanu {...props} />;


    default:
      return <ClaimsDashboardDefault />;
  }
};

export const ClaimInitiation = (props) => {
  switch (partnerGuid) {
    case PARTNERS_GUID_ENUM.ACCESS_BANK:
    case PARTNERS_GUID_ENUM.INSOLCOMPLEX:
    case PARTNERS_GUID_ENUM.OLDMUTUAL_UGANDA_POSTBANK:
    case PARTNERS_GUID_ENUM.OLDMUTUAL_UGANDA_ROTARY:
    case PARTNERS_GUID_ENUM.OLDMUTUAL_UGANDA_NAMIREMBE:
    case PARTNERS_GUID_ENUM.OLDMUTUAL_CENTENARY_BANK:
    case PARTNERS_GUID_ENUM.OLDMUTUAL_DFCU_UG:
    case PARTNERS_GUID_ENUM.OLDMUTUAL_UGANDA_LIONSCLUB:
    case PARTNERS_GUID_ENUM.marketplace_a:
    case PARTNERS_GUID_ENUM.marketplace_b:
    case PARTNERS_GUID_ENUM.marketplace_c:
      return <ClaimInitiationAccessBank {...props} />;
    case PARTNERS_GUID_ENUM.BBOX_KENYA:
    case PARTNERS_GUID_ENUM.BBOX_RWANDA:
      return <ClaimInitiationBboxx {...props} />;

    case PARTNERS_GUID_ENUM.REAL_PEOPLE:
    case PARTNERS_GUID_ENUM.SHIPRAZOR_SOUTH_AFRICA:
    case PARTNERS_GUID_ENUM.SHIPRAZOR_KENYA:
    case PARTNERS_GUID_ENUM.SENTI:
      return <ClaimInitiationRealPeople {...props} />;

    case PARTNERS_GUID_ENUM.KTDA:
    case PARTNERS_GUID_ENUM.ASPIN_PLUS:
      return <ClaimInitiationKTDA {...props} />;

    case PARTNERS_GUID_ENUM.EUNIFIN_GHANA:
    case PARTNERS_GUID_ENUM.EUNIFIN_SENEGAL:
      return <ClaimInitiationEunifin {...props} />;

    case PARTNERS_GUID_ENUM.HEALTH_ENTREPRENEURS:
      return <ClaimInitiationHe {...props} />;


    case PARTNERS_GUID_ENUM.OLDMUTUAL_MALAWI:
      return <ClaimInitiationOldMutualMalawi {...props} />;

    case PARTNERS_GUID_ENUM.MZANU:
    case PARTNERS_GUID_ENUM.OLDMUTUAL_KENYA:
    case PARTNERS_GUID_ENUM.OLDMUTUAL_UGANDA_FLP:
    case PARTNERS_GUID_ENUM.SAMBA:
      return <ClaimInitiationMzanu {...props} />;

    case PARTNERS_GUID_ENUM.COVER_LINK:
      return <ClaimInitiationCoverLink {...props} />;

    default:
      // Phase E: config-driven renderer; falls back to ClaimInitiationKTDA
      // if no org claim_init_data config is found (safe for existing partners).
      return (
        <ClaimInitiationConfigurable
          fallback={<ClaimInitiationKTDA {...props} />}
          {...props}
        />
      );
  }
};

export const ClaimProcessing = (props) => {
  switch (partnerGuid) {
    case PARTNERS_GUID_ENUM.ACCESS_BANK:
    case PARTNERS_GUID_ENUM.ASPIN_PLUS:
    case PARTNERS_GUID_ENUM.INSOLCOMPLEX:
    case PARTNERS_GUID_ENUM.OLDMUTUAL_UGANDA_POSTBANK:
    case PARTNERS_GUID_ENUM.OLDMUTUAL_UGANDA_ROTARY:
    case PARTNERS_GUID_ENUM.OLDMUTUAL_DFCU_UG:
    case PARTNERS_GUID_ENUM.OLDMUTUAL_UGANDA_LIONSCLUB:
      return <ClaimsProcessingAccessBank {...props} />;
    case PARTNERS_GUID_ENUM.BBOX_KENYA:
    case PARTNERS_GUID_ENUM.BBOX_RWANDA:
      return <ClaimsProcessingBboxx {...props} />;
    case PARTNERS_GUID_ENUM.KTDA:
      return <ClaimsProcessingKTDA {...props} />;

    case PARTNERS_GUID_ENUM.NGS_UGANDA:
      return <ClaimProcessingNGSGroup {...props} />;

    case PARTNERS_GUID_ENUM.REAL_PEOPLE:
    case PARTNERS_GUID_ENUM.SHIPRAZOR_SOUTH_AFRICA:
    case PARTNERS_GUID_ENUM.SHIPRAZOR_KENYA:
    case PARTNERS_GUID_ENUM.SENTI:
      return <ClaimProcessingRealPeople {...props} />;

    case PARTNERS_GUID_ENUM.EUNIFIN_GHANA:
    case PARTNERS_GUID_ENUM.EUNIFIN_SENEGAL:
      return <ClaimProcessingEunifin {...props} />;

    case PARTNERS_GUID_ENUM.HEALTH_ENTREPRENEURS:
      return <ClaimProcessingHe {...props} />;

    case PARTNERS_GUID_ENUM.COVER_LINK:
      return <ClaimProcessingCoverLink {...props} />;


    case PARTNERS_GUID_ENUM.OLDMUTUAL_MALAWI:
      return <ClaimProcessingOldMutualMalawi {...props} />;

    case PARTNERS_GUID_ENUM.MZANU:
    case PARTNERS_GUID_ENUM.OLDMUTUAL_KENYA:
    case PARTNERS_GUID_ENUM.OLDMUTUAL_UGANDA_FLP:
    case PARTNERS_GUID_ENUM.SAMBA:
     case PARTNERS_GUID_ENUM.marketplace_a: 
    case PARTNERS_GUID_ENUM.marketplace_b: 
    case PARTNERS_GUID_ENUM.marketplace_c: 
      return <ClaimProcessingMzanu {...props} />;
    default:
      return <ClaimsProcessingKTDA {...props} />;
  }
};

export const BulkPolicyOnboarding = () => {
  switch (partnerGuid) {
    case PARTNERS_GUID_ENUM.KTDA:
    case PARTNERS_GUID_ENUM.ACCESS_BANK:
    case PARTNERS_GUID_ENUM.ASPIN_PLUS:
    case PARTNERS_GUID_ENUM.INSOLCOMPLEX:
    case PARTNERS_GUID_ENUM.BBOX_KENYA:
    case PARTNERS_GUID_ENUM.BBOX_RWANDA:
    case PARTNERS_GUID_ENUM.MANANKIFIN:
    case PARTNERS_GUID_ENUM.FAITH_FUNERALS:
    case PARTNERS_GUID_ENUM.REAL_PEOPLE:
    case PARTNERS_GUID_ENUM.SHIPRAZOR_SOUTH_AFRICA:
    case PARTNERS_GUID_ENUM.SHIPRAZOR_KENYA:
    case PARTNERS_GUID_ENUM.EUNIFIN_GHANA:
    case PARTNERS_GUID_ENUM.EUNIFIN_SENEGAL:
    case PARTNERS_GUID_ENUM.OLDMUTUAL_UGANDA_ROTARY:
    case PARTNERS_GUID_ENUM.OLDMUTUAL_UGANDA_NAMIREMBE:
    case PARTNERS_GUID_ENUM.OLDMUTUAL_UGANDA_POSTBANK:
    case PARTNERS_GUID_ENUM.OLDMUTUAL_UGANDA_FLP:
    case PARTNERS_GUID_ENUM.OLDMUTUAL_CENTENARY_BANK:
    case PARTNERS_GUID_ENUM.OLDMUTUAL_DFCU_UG:
    case PARTNERS_GUID_ENUM.SENTI:
    case PARTNERS_GUID_ENUM.OLDMUTUAL_UGANDA_LIONSCLUB:
    case PARTNERS_GUID_ENUM.OLDMUTUAL_MALAWI:
    case PARTNERS_GUID_ENUM.marketplace_a: 
    case PARTNERS_GUID_ENUM.marketplace_b: 
    case PARTNERS_GUID_ENUM.marketplace_c: 
      return <BulkPolicyOnboardingKTDA />;
    default:
      return <PageNotFound />;
  }
};

export const FailedEnteries = (props) => {
  switch (partnerGuid) {
    case PARTNERS_GUID_ENUM.KTDA:
    case PARTNERS_GUID_ENUM.BBOX_KENYA:
    case PARTNERS_GUID_ENUM.BBOX_RWANDA:
    case PARTNERS_GUID_ENUM.ACCESS_BANK:
    case PARTNERS_GUID_ENUM.ASPIN_PLUS:
    case PARTNERS_GUID_ENUM.SHIPRAZOR_SOUTH_AFRICA:
    case PARTNERS_GUID_ENUM.SHIPRAZOR_KENYA:
    case PARTNERS_GUID_ENUM.EUNIFIN_GHANA:
    case PARTNERS_GUID_ENUM.EUNIFIN_SENEGAL:
    case PARTNERS_GUID_ENUM.OLDMUTUAL_UGANDA_ROTARY:
    case PARTNERS_GUID_ENUM.OLDMUTUAL_UGANDA_NAMIREMBE:
    case PARTNERS_GUID_ENUM.OLDMUTUAL_UGANDA_POSTBANK:
    case PARTNERS_GUID_ENUM.OLDMUTUAL_UGANDA_FLP:
    case PARTNERS_GUID_ENUM.OLDMUTUAL_CENTENARY_BANK:
    case PARTNERS_GUID_ENUM.OLDMUTUAL_DFCU_UG:
    case PARTNERS_GUID_ENUM.OLDMUTUAL_UGANDA_LIONSCLUB:
   case PARTNERS_GUID_ENUM.marketplace_a: 
    case PARTNERS_GUID_ENUM.marketplace_b: 
    case PARTNERS_GUID_ENUM.marketplace_c: 
      return <FailedEnteriesKTDA {...props} />;
    default:
      return <FailedEnteriesKTDA {...props} />;
  }
};

// payments
export const BulkPayments = () => {
  switch (partnerGuid) {
    case PARTNERS_GUID_ENUM.KTDA:
    case PARTNERS_GUID_ENUM.INSOLCOMPLEX:
    case PARTNERS_GUID_ENUM.ASPIN_PLUS:
    case PARTNERS_GUID_ENUM.REAL_PEOPLE:
    case PARTNERS_GUID_ENUM.SHIPRAZOR_SOUTH_AFRICA:
    case PARTNERS_GUID_ENUM.SHIPRAZOR_KENYA:
    case PARTNERS_GUID_ENUM.EUNIFIN_GHANA:
    case PARTNERS_GUID_ENUM.EUNIFIN_SENEGAL:
    case PARTNERS_GUID_ENUM.OLDMUTUAL_UGANDA_ROTARY:
    case PARTNERS_GUID_ENUM.OLDMUTUAL_UGANDA_NAMIREMBE:
    case PARTNERS_GUID_ENUM.OLDMUTUAL_UGANDA_POSTBANK:
    case PARTNERS_GUID_ENUM.OLDMUTUAL_UGANDA_FLP:
    case PARTNERS_GUID_ENUM.OLDMUTUAL_CENTENARY_BANK:
    case PARTNERS_GUID_ENUM.OLDMUTUAL_DFCU_UG:
    case PARTNERS_GUID_ENUM.OLDMUTUAL_UGANDA_LIONSCLUB:
    case PARTNERS_GUID_ENUM.marketplace_a: 
    case PARTNERS_GUID_ENUM.marketplace_b: 
    case PARTNERS_GUID_ENUM.marketplace_c: 
      return <BulkPaymentsKTDA />;
    default:
      return <BulkPaymentsKTDA />;
  }
};

export const FailedPaymentsEnteries = (props) => {
  switch (partnerGuid) {
    case PARTNERS_GUID_ENUM.KTDA:
    case PARTNERS_GUID_ENUM.INSOLCOMPLEX:
    case PARTNERS_GUID_ENUM.ASPIN_PLUS:
    case PARTNERS_GUID_ENUM.REAL_PEOPLE:
    case PARTNERS_GUID_ENUM.SHIPRAZOR_SOUTH_AFRICA:
    case PARTNERS_GUID_ENUM.SHIPRAZOR_KENYA:
    case PARTNERS_GUID_ENUM.EUNIFIN_GHANA:
    case PARTNERS_GUID_ENUM.EUNIFIN_SENEGAL:
    case PARTNERS_GUID_ENUM.OLDMUTUAL_UGANDA_ROTARY:
    case PARTNERS_GUID_ENUM.OLDMUTUAL_UGANDA_NAMIREMBE:
    case PARTNERS_GUID_ENUM.OLDMUTUAL_UGANDA_POSTBANK:
    case PARTNERS_GUID_ENUM.OLDMUTUAL_UGANDA_FLP:
    case PARTNERS_GUID_ENUM.OLDMUTUAL_CENTENARY_BANK:
    case PARTNERS_GUID_ENUM.OLDMUTUAL_DFCU_UG:
    case PARTNERS_GUID_ENUM.OLDMUTUAL_UGANDA_LIONSCLUB:
      return <FailedPaymentsEnteriesKTDA {...props} />;
    default:
      return <FailedPaymentsEnteriesKTDA {...props} />;
  }
};

export const KnowledgeBase = (props) => <KnowledgeBaseShared {...props} />;

export const ViewGuide = (props) => <ViewGuideShared {...props} />;

export const elasticSearch = (props) => {
  switch (partnerGuid) {
    case PARTNERS_GUID_ENUM.ACCESS_BANK:
    case PARTNERS_GUID_ENUM.NGS_UGANDA:
    case PARTNERS_GUID_ENUM.REAL_PEOPLE:
    case PARTNERS_GUID_ENUM.OLDMUTUAL_UGANDA_ROTARY:
    case PARTNERS_GUID_ENUM.OLDMUTUAL_UGANDA_NAMIREMBE:
    case PARTNERS_GUID_ENUM.OLDMUTUAL_UGANDA_POSTBANK:
    case PARTNERS_GUID_ENUM.OLDMUTUAL_CENTENARY_BANK:
    case PARTNERS_GUID_ENUM.OLDMUTUAL_DFCU_UG:
    case PARTNERS_GUID_ENUM.OLDMUTUAL_UGANDA_LIONSCLUB:
      return <ElasticSearch {...props} />;
    default:
      return <ElasticSearch {...props} />;
  }
};

export const Death_Claims = (props) => {
  switch (partnerGuid) {
    case PARTNERS_GUID_ENUM.REAL_PEOPLE:
    case PARTNERS_GUID_ENUM.EUNIFIN_GHANA:
    case PARTNERS_GUID_ENUM.EUNIFIN_SENEGAL:
      return <RealPeopleDeathClaims {...props} />;
    case PARTNERS_GUID_ENUM.KTDA:
      return <DeathClaimsDashboardKtda {...props} />;

    case PARTNERS_GUID_ENUM.ACCESS_BANK:
    case PARTNERS_GUID_ENUM.OLDMUTUAL_UGANDA_POSTBANK:
    case PARTNERS_GUID_ENUM.OLDMUTUAL_UGANDA_LIONSCLUB:
    case PARTNERS_GUID_ENUM.OLDMUTUAL_CENTENARY_BANK:
    case PARTNERS_GUID_ENUM.OLDMUTUAL_DFCU_UG:
    case PARTNERS_GUID_ENUM.OLDMUTUAL_UGANDA_FLP:
    case PARTNERS_GUID_ENUM.OLDMUTUAL_UGANDA_ROTARY:
    case PARTNERS_GUID_ENUM.OLDMUTUAL_UGANDA_NAMIREMBE:
      return <DeathClaimsDashboardAccessbank {...props} />;

    case PARTNERS_GUID_ENUM.BBOX_RWANDA:
    case PARTNERS_GUID_ENUM.BBOX_KENYA:
      return <BboxxDeathClaimsDashbaord {...props} />;


    case PARTNERS_GUID_ENUM.HEALTH_ENTREPRENEURS:
      return <HeLastExpenseDasboared {...props} />;

    default:
      return <PageNotFound {...props} />;
  }
};

export const Disability_Claims = (props) => {
  switch (partnerGuid) {
    case PARTNERS_GUID_ENUM.REAL_PEOPLE:
    case PARTNERS_GUID_ENUM.EUNIFIN_GHANA:
    case PARTNERS_GUID_ENUM.EUNIFIN_SENEGAL:
      return <RealPeopleDisabilityClaims {...props} />;
    case PARTNERS_GUID_ENUM.BBOX_RWANDA:
    case PARTNERS_GUID_ENUM.BBOX_KENYA:
      return <BboxxDisabilityClaimsDashboard {...props} />;

    default:
      return <PageNotFound {...props} />;
  }
};

export const Hospital_claims = (props) => {
  switch (partnerGuid) {
    case PARTNERS_GUID_ENUM.REAL_PEOPLE:
    case PARTNERS_GUID_ENUM.EUNIFIN_GHANA:
    case PARTNERS_GUID_ENUM.EUNIFIN_SENEGAL:
      return <RealPeopleHospitalClaims {...props} />;
    case PARTNERS_GUID_ENUM.KTDA:
      return <HospitalClaimDashboardKtda {...props} />;

    case PARTNERS_GUID_ENUM.BBOX_RWANDA:
    case PARTNERS_GUID_ENUM.BBOX_KENYA:
      return <BboxxHospitalClaimsDashboard {...props} />;

    case PARTNERS_GUID_ENUM.HEALTH_ENTREPRENEURS:
      return <HeHospitalClaimsDashboard {...props} />;

    case PARTNERS_GUID_ENUM.MZANU:
      return <MzanuHospiCashIllnessBenefit {...props} />;

    case PARTNERS_GUID_ENUM.OLDMUTUAL_MALAWI:
      return <OmmHospitalClaims {...props} />;

    default:
      return <PageNotFound {...props} />;
  }
};
export const Hospital_Cash_Accident_Claims = (props) => {
  switch (partnerGuid) {

    case PARTNERS_GUID_ENUM.MZANU:
      return <MzanuHospitalCashAccidentBenefit {...props} />;



    default:
      return <PageNotFound {...props} />;
  }
};


export const Last_Expense_claims = (props) => {
  switch (partnerGuid) {
    case PARTNERS_GUID_ENUM.REAL_PEOPLE:
      return <RealPeopleLastExpenseClaims {...props} />;
    default:
      return <PageNotFound {...props} />;
  }
};

export const property_claims = (props) => {
  switch (partnerGuid) {
    case PARTNERS_GUID_ENUM.REAL_PEOPLE:
      return <RealPeoplePropertyClaims {...props} />;
    default:
      return <PageNotFound {...props} />;
  }
};

export const Reimbursement_claims = (props) => {
  switch (partnerGuid) {
    case PARTNERS_GUID_ENUM.KTDA:
      return <ReimbursementClaimsDashboardKtda {...props} />;
    default:
      return <PageNotFound {...props} />;
  }
};

export const Device_Damage_Claims = (props) => {
  switch (partnerGuid) {
    case PARTNERS_GUID_ENUM.BBOX_RWANDA:
    case PARTNERS_GUID_ENUM.BBOX_KENYA:
      return <BboxxDeviceDamageClaimsDashboard {...props} />;
    default:
      return <PageNotFound {...props} />;
  }
};

export const Device_theft_Claims = (props) => {
  switch (partnerGuid) {
    case PARTNERS_GUID_ENUM.BBOX_RWANDA:
    case PARTNERS_GUID_ENUM.BBOX_KENYA:
      return <BboxxDeviceTheftClaimsDashboard {...props} />;
    default:
      return <PageNotFound {...props} />;
  }
};

export const Funeral_Claims = (props) => {
  switch (partnerGuid) {
    case PARTNERS_GUID_ENUM.MZANU:
      case PARTNERS_GUID_ENUM.OLDMUTUAL_KENYA:
      return <MzanuFuneralClaims {...props} />;

    case PARTNERS_GUID_ENUM.OLDMUTUAL_MALAWI:
      return <OmmFuneralClaims {...props} />;

    default:
      return <PageNotFound {...props} />;
  }
};

export const Critical_Illness_Claims = (props) => {
  switch (partnerGuid) {
    case PARTNERS_GUID_ENUM.EUNIFIN_GHANA:
    case PARTNERS_GUID_ENUM.EUNIFIN_SENEGAL:
      return <EunifinCriticalIllnessClaims {...props} />;
    default:
      return <PageNotFound {...props} />;
  }
};

export const Cancer_Care_Claims = (props) => {
  switch (partnerGuid) {
    case PARTNERS_GUID_ENUM.HEALTH_ENTREPRENEURS:
      return <HeCancerCareClaims {...props} />;
    default:
      return <PageNotFound {...props} />;
  }
};


export const Cover_Link_Medical_Cash_Claims = (props) => {
  switch (partnerGuid) {
    case PARTNERS_GUID_ENUM.COVER_LINK:
      return <CoverLinkMedicalCashClaims {...props} />;
    default:
      return <PageNotFound {...props} />;
  }
};

export const Cover_Link_Legal_Claims = (props) => {
  switch (partnerGuid) {
    case PARTNERS_GUID_ENUM.COVER_LINK:
      return <CoverLinkLegalClaims {...props} />;
    default:
      return <PageNotFound {...props} />;
  }
};

/**
 * Phase E — IPP Launcher
 * Renders the configured IPP iframe for the current partner.
 * No partner-specific switch needed — the renderer resolves the right
 * config from the org's ipp_data blob at runtime.
 * Usage in routes/index.js: import { IppLauncherPage } from './components';
 */
export const IppLauncherPage = (props) => {
  return <IppLauncher journeyCode={props.journeyCode || 'onboarding'} {...props} />;
};

export const PoliciesDashboard = (props) => {
  switch (partnerGuid) {
    case PARTNERS_GUID_ENUM.OLDMUTUAL_MALAWI:
      return <OmmAmlDesk {...props} />;
    case PARTNERS_GUID_ENUM.MMI_GHANA:
      return <EmplifePlusPoliciesDashboard {...props} />;
    default:
      return <PoliciesDashboardAccessBank {...props} />;
  }
};

export const RecentPolicies = (props) => {
  switch (partnerGuid) {
    case PARTNERS_GUID_ENUM.OLDMUTUAL_MALAWI:
      return <OmmNewBusiness {...props} />;
    default:
      return <RecentPoliciesShared {...props} />;
  }
};
